import { IDeliveryZone } from "@app/common";

export type DeliveryZoneFormValues = Partial<IDeliveryZone> & {
  _selectedDays?: string[];
  _startTime?: string;
  _endTime?: string;
};

export const transformToUpdatableFormDeliveryZone = (deliveryZone?: Partial<IDeliveryZone>): DeliveryZoneFormValues => {
  if (!deliveryZone) {
    return {
      name: '',
      extraDeliveryTime: 0,
      minPrice: 0,
      disabled: false,
      fees: {
        amount: 0,
      },
      schedule: {},
      _selectedDays: [],
      _startTime: '',
      _endTime: '',
    };
  }

  return {
    ...deliveryZone,
    // On ne touche pas aux moyens de paiement : ils sont gérés côté back,
    // et il n'y a pas de champ dans le formulaire pour les modifier pour l'instant.
    fees: deliveryZone.fees || { amount: 0 },
    schedule: deliveryZone.schedule || {},
    _selectedDays: [],
    _startTime: '',
    _endTime: '',
  };
};
